<template>
  <div
    class="alert flex flex-row items-center bg-indigo-200 p-5 rounded border-b-2 border-indigo-400"
  >
    <div
      class="alert-icon flex items-center bg-blue-100 border-2 border-indigo-500 justify-center h-10 w-10 flex-shrink-0 rounded-full"
    >
      <font-awesome-icon
        icon="info-circle"
        class="align-middle text-indigo-700"
        type="solid"
      />
    </div>
    <div class="ml-4">
      <div class="font-semibold text-md text-blue-800">
        Nenhum produto cadastrado
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style>
</style>
